module.exports = __webpack_public_path__ + "img/kk.c530fbcb.png";